// extracted by mini-css-extract-plugin
export var contact = "footer-module--contact--96ca8";
export var container = "footer-module--container--f1eb9";
export var copyright = "footer-module--copyright--37395";
export var utilMenu = "footer-module--utilMenu--36f68";